import Image from 'next/image';
import React, { useMemo } from 'react';

import { Text } from '@/design-system/components/ui';

import { EventTriggerType } from '../../../domain';
import { TRIGGER_TYPE_MAP } from '../../../domain/mappers';
import { triggerOptions } from '../../TriggerTypeSelectorModal';

interface Props {
  eventType: EventTriggerType;
}

export const TriggerType = ({ eventType }: Props) => {
  const triggerLogo = useMemo(() => {
    const option = triggerOptions.find((opt) =>
      eventType == EventTriggerType.OnChainFunction
        ? opt.triggerType === EventTriggerType.OnChain
        : opt.triggerType === eventType,
    );
    return option?.imageSrc;
  }, [eventType]);

  return (
    <div className="tw:flex tw:flex-col">
      <Text variant="body-sm" weight="bold" className="tw:mb-1">
        Type
      </Text>
      <div className="tw:flex tw:flex-row tw:gap-1 tw:items-center">
        {typeof triggerLogo === 'string' ? (
          <Image
            alt={TRIGGER_TYPE_MAP[eventType] || ''}
            width={20}
            height={20}
            style={{
              maxHeight: 20,
              objectFit: 'contain',
            }}
            src={triggerLogo}
          />
        ) : (
          triggerLogo && React.cloneElement(triggerLogo as React.ReactElement<{ size?: number }>, { size: 20 })
        )}
        <Text variant="body-sm" className="tw:py-0.5 tw:truncate">
          {TRIGGER_TYPE_MAP[eventType]}
        </Text>
      </div>
    </div>
  );
};
